import { HttpApiError, HttpApiGroup } from "@effect/platform";
import { endpoint } from "../auth/endpoint";
import { DatabaseError, DataIntegrityError } from "../auth/errors";
import { MeResponse } from "../models/me";

export const MeGroup = HttpApiGroup.make("me")
  .add(
    endpoint.merchant
      .get("getMe", "/me")
      .addSuccess(MeResponse)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
